import React, { useMemo } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { Platform, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useSelector } from 'react-redux';
import { useTheme } from '../theme';
import { HOME_INDICATOR_OVERLAP } from '../design/components/AppTabBar';
import { useFieldTabBarHeight } from '../components/navigation/fieldTabBarHeight';

import AuthenticatedAppStack from './AuthenticatedAppStack';
import UnauthenticatedAppStack from './UnauthenticatedAppStack';

const AppNavigation = () => {
	const { theme } = useTheme();
	const safeAreaInsets = useSafeAreaInsets();
	const isTabBarShown = useFieldTabBarHeight() > 0;
	// The iPhone bottom bar reaches into the home-indicator strip (AppTabBar).
	const bottomInset = Platform.OS === 'ios' && isTabBarShown && safeAreaInsets.bottom > HOME_INDICATOR_OVERLAP
		? safeAreaInsets.bottom - HOME_INDICATOR_OVERLAP
		: safeAreaInsets.bottom;
	const safeAreaStyle = useMemo(() => ({
		flex: 1,
		// Matches the header and bottom bar surface so the home-indicator strip blends in.
		backgroundColor: theme.ui.colors.surface,
		paddingBottom: bottomInset,
	}), [bottomInset, theme.ui.colors.surface]);

	// Get authentication state from Redux
	const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

	return (
		<NavigationContainer>
			{/* Match SafeArea background with the active theme to avoid white bars in dark mode */}
			<View style={safeAreaStyle}>
				{
					isAuthenticated
						? <AuthenticatedAppStack />
						: <UnauthenticatedAppStack />
				}
			</View>
		</NavigationContainer>
	);
};

export default AppNavigation;
